import React, { Component } from 'react';
import { Button, Divider, Paper, Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import Datasheet from 'react-datasheet';
import i18n from '../../i18n';
import 'react-datasheet/lib/react-datasheet.css';
import '../../assets/stylesheets/SkuCarryover.css';

class AddSkuSpreadsheet extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputtedSkus: [],
      grid: this.initializeGrid(),
    };
  }

  initializeGrid = () => {
    const grid = [];
    grid.push([
      { readOnly: true, value: '' },
      { value: i18n.t('carryover:oldSku'), readOnly: true },
      { value: i18n.t('carryover:newSku'), readOnly: true },
    ]);
    for (let i = 1; i < 50; i++) {
      const entry = [
        { readOnly: true, value: '' },
        { value: '' },
        { value: '' },
      ];
      grid.push(entry);
    }

    return grid;
  };

  valueRenderer = (cell) => cell.value;

  dataRenderer = (cell) => {
    cell.value.toString();
  };

  handleChanges = (changes, additional) => {
    const { grid } = this.state;
    const gridNew = grid.map((row) => [...row]);
    // eslint-disable-next-line no-unused-vars
    changes.forEach(({ cell, row, col, value }) => {
      if (gridNew[row] && gridNew[row][col]) {
        gridNew[row][col] = { ...gridNew[row][col], value };
      }
    });
    // the following piece takes care of additional spreadsheet lines if there is an overflow.
    if (additional) {
      additional.forEach(({ row, col, value }) => {
        if (col === 1) {
          const entry0 = {
            readOnly: true,
            value: row,
          };
          const entry1 = { value };
          const entry2 = { value: '' };
          const newDataPoint = [entry0, entry1, entry2];
          gridNew.push(newDataPoint);
        }
        if (col === 2) {
          gridNew[row][col] = { ...gridNew[row][col], value };
        }
      });
    }

    return this.setState({ grid: gridNew });
  };

  onContextMenu = (e, cell) => (cell.readOnly ? e.preventDefault() : null);

  handleChange = (event) => {
    event.persist();
    const { name, value } = event.target;

    this.setState((prevState) => {
      return {
        [name]: value,
        edited: {
          ...prevState.edited,
          [name]: true,
        },
      };
    });
  };

  cellRenderer = (params) => {
    const {
      row,
      col,
      cell,
      children,
      editing,
      updated,
      attributesRenderer,
      ...rest
    } = params;
    let style;
    style = {
      fontSize: '12px',
      width: '200px',
    };
    if (col === 0) {
      style = {
        width: '0px',
      };
    }

    return (
      // eslint-disable-next-line react/jsx-props-no-spreading
      <td {...rest} style={style}>
        {params.children}
      </td>
    );
  };

  handleAddToTable = () => {
    const { grid, inputtedSkus } = this.state;
    const { refreshSkus } = this.props;

    grid.forEach((entry) => {
      if (entry[1].readOnly && entry[2].readOnly) {
        return;
      }

      if (entry[1].value !== '' && entry[2].value !== '') {
        const skuPair = {
          oldSku: entry[1].value,
          newSku: entry[2].value,
        };
        inputtedSkus.push(skuPair);
      }
    });

    this.setState({ inputtedSkus });
    // pass inputted skus to SkuTable and clear the inputted Skus state
    refreshSkus(inputtedSkus);
    this.setState({ inputtedSkus: [] });
  };

  handleClear = () => {
    const newGrid = this.initializeGrid();
    this.setState({ grid: newGrid });
  };

  render() {
    const { grid } = this.state;

    return (
      <Paper className="addSkusSpreadsheet">
        <Grid container>
          <Grid item xs={12}>
            {i18n.t('carryover:inputTableTitle')}
          </Grid>
          <Grid item xs={12}>
            <Paper style={{ maxHeight: 450, overflow: 'auto' }}>
              <Datasheet
                data={grid}
                valueRenderer={this.valueRenderer}
                dataRenderer={this.dataRenderer}
                onContextMenu={this.onContextMenu}
                onCellsChanged={this.handleChanges}
                cellRenderer={this.cellRenderer}
              />
            </Paper>
            <Divider />
            <br />
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={this.handleAddToTable}
              className="ssenseButton ssensePrimary"
            >
              {i18n.t('carryover:addBtn')}
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button
              onClick={this.handleClear}
              className="ssenseButton ssenseDefault"
            >
              {i18n.t('carryover:clearBtn')}
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

AddSkuSpreadsheet.propTypes = {
  refreshSkus: PropTypes.func.isRequired,
};

export default AddSkuSpreadsheet;
